import { render, staticRenderFns } from "./CombinedInvoices.vue?vue&type=template&id=3cb7c5ba"
import script from "./CombinedInvoices.vue?vue&type=script&lang=js"
export * from "./CombinedInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports